import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Sidebar from './Sidebar'
import MainMenu from './MainMenu'
import DynamicSection from './DynamicSection'
import * as ComponentActions from '../actions'
import commonUI from '../../js/commonUI'
import { offcanvasMenu, initPlugins } from '../lib/utils'

class Home extends Component {

  constructor({ components }) {
    super()
  }

  componentDidMount() {
    setTimeout(() => {
      commonUI.initializeNavigation();
      $('.fitText').fitText(1.2, { minFontSize: '20px', maxFontSize: '110px' });
      offcanvasMenu();
      initPlugins();
    }, 0)
  }

  getFilteredContent(components) {
    return components.Home
  }

  renderMainMenu(components, staticVersion) {
    return (<MainMenu selected="Home" components={components} staticVersion={staticVersion} />)
  }

  renderSidebar(filteredContent, staticVersion) {
    return (<Sidebar sections={[]} selected="Home" staticVersion={staticVersion} />)
  }

  render (){

    const { components } = this.props
    const staticVersion = this.props.config.staticVersion;
    const filteredContent = this.getFilteredContent(components);

    return(
      <div>
        {this.renderMainMenu(components, staticVersion)}
        {this.renderSidebar(filteredContent, staticVersion)}
        <div id="main" className="content--full">
          {filteredContent.map((object, index) => {
            return (
              <DynamicSection
                key={object.template}
                sectionName={object.template}
                staticVersion={staticVersion}/>
            )
          })}
        </div>
      </div>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(ComponentActions, dispatch)
  }
}

function mapStateToProps(state) {
  return { components: state.components, config: state.config }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home)



// WEBPACK FOOTER //
// ./styleguide/components/Home.js